import React from 'react';

const ExternalUserNoIncidents: React.FC = () => {
  return (
    <div className="d-flex flex-column align-items-center justify-content-center ">
      <h1 className="display-txt--lg mb-3">{'No Incidents Found'}</h1>
      <p className="mb-4">
        {
          "External users only have access to the incidents they've been assigned, and you have no assigned incidents. If you believe this is an error, please contact your administrator."
        }
      </p>
    </div>
  );
};

export default ExternalUserNoIncidents;
